// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

// Your web app's Firebase configuration
/*const firebaseConfig = { // dev
    apiKey: "AIzaSyBn8Zm7-gMftJy9vHz_rzl-UZnQ-M37ETw",
    authDomain: "webauthn-front-test.firebaseapp.com",
    projectId: "webauthn-front-test",
    storageBucket: "webauthn-front-test.firebasestorage.app",
    messagingSenderId: "418176494450",
    appId: "1:418176494450:web:db170346ab6b41d4418beb"
};/**/

const firebaseConfig = { // prod
    apiKey: "AIzaSyAEaAqOwq9EtlSYeJir5yUi0hUcO1SRXr4",
    authDomain: "ly-backend-db.firebaseapp.com",
    projectId: "ly-backend-db",
    storageBucket: "ly-backend-db.firebasestorage.app",
    messagingSenderId: "739192570135",
    appId: "1:739192570135:web:6a89488c9d481f797ff752"
};/**/

export const app = firebase.initializeApp(firebaseConfig);

// tosUrl and privacyPolicyUrl accept either url string or a callback function.
export function startFirebase(container, signInSuccessUrl) {
    // FirebaseUI config.
    var uiConfig = {
        callbacks: {
            signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                // User successfully signed in.
                // Return type determines whether we continue the redirect automatically
                // or whether we leave that to developer to handle.
                console.log('signInSuccessWithAuthResult');
                console.log(authResult, redirectUrl);
                return true;
            },
            uiShown: function() {
                // The widget is rendered.
                // Hide the loader.
                console.log('uiShown');
                //document.getElementById('loader').style.display = 'none';
            },
            signInFailure: function(error) {
                console.error('signInFailure', error);
            },
        },
        signInSuccessUrl,
        signInFlow: 'popup',
        signInOptions: [{
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                clientId: '739192570135-auq6elgg8240uuiehhfglcapkpt8q2nf.apps.googleusercontent.com',
            },
            firebase.auth.GithubAuthProvider.PROVIDER_ID,
            {
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
            },
        ],
        tosUrl: 'https://www.securely.id/policy',
        privacyPolicyUrl: 'https://www.securely.id/policy',
      };

      const auth = firebase.auth();
      auth.getRedirectResult().then(function(result) {
          console.log('redirect result');
          console.log(result);
      }).catch(console.error);
      // Initialize the FirebaseUI Widget using Firebase.
      var ui = new firebaseui.auth.AuthUI(auth);
      // The start method will wait until the DOM is loaded.
      ui.start(container, uiConfig);

      return auth;
}

export default { app, startFirebase };
